<script setup lang='ts'>
defineOptions({

})
definePage({
  meta: {
    layout: 'default',
    title: 'THE-SECOND',
    keepAlive: true,
    icon: 'i-mage-dots-menu',
  },
})
</script>

<template>
  <div class="wh-full flex-col-center gap-10">
    Hello! THE-SECOND
  </div>
</template>

<style scoped lang='less'>

</style>
